import React, { useCallback } from "react";
import _ from "lodash";
import Socket from "socket";
import DefaultDiscoverScreen from "./DefaultDiscoverScreen";
import DiscoveryDice123 from "./DiscoveryDice123";
import tech from "assets/images/ct/tech.png";
import aliens from "assets/images/ct/aliens.png";
import schemes from "assets/images/ct/schemes.png";
import mythos from "assets/images/ct/mythos.png";
import random from "assets/images/ct/random.png";
import one from "assets/images/ct/one-arrow.png";
import two from "assets/images/ct/two-arrow.png";
import three from "assets/images/ct/three-arrow.png";
import four from "assets/images/ct/four-arrow.png";
import five from "assets/images/ct/five-arrow.png";
import six from "assets/images/ct/six-arrow.png";

import DiscoverySingleCommon from "./DiscoverySingleCommon";
import DiscoveryCardSelector from "./DiscoveryCardSelector";
import { useDispatch } from "react-redux";
import { set_ct_steal_button } from "redux/game/action";

const DiscoveryScreen = ({
  diceData,
  screens,
  currentPlayer,
  roomId,
  discard_pile,
  playersWithCard,
  OtherPlayers,
  playersWithCardInfo,
  playerSelected,
  cardSelected,
  stealButton,buzzer_sound,default_audio_effect
}) => {
  const dd_button = _.get(screens, "discovery.dd_button", "END TURN");
  const dd_info_1 = _.get(
    screens,
    "discovery.dd_info_1",
    "No shame in it! The truth's gotta be free... even if it stinks. Literally."
  );
  const dd_info_2 = _.get(screens, "discovery.dd_info_2", "You found a card!");

  const dd_info_empty_1 = _.get(
    screens,
    "discovery.dd_info_empty_1",

    "You've never seen a dumpster this clean before, there's nothing to find!"
  );

  const dd_info_empty_2 = _.get(
    screens,
    "discovery.dd_info_empty_2",

    "The discard pile was empty, and you don't find anything."
  );
  const dd_title = _.get(screens, "discovery.dd_title", "DUMPSTER DIVE!");
  const discovery_button = _.get(
    screens,
    "discovery.discovery_button",
    "ROLL THE DICE"
  );
  const discovery_info = _.get(
    screens,
    "discovery.discovery_info",
    "Eureka! You really think you're on to somethin' now. Roll again to see what."
  );
  const discovery_title = _.get(
    screens,
    "discovery.discovery_title",
    "DISCOVERY!"
  );

  const iam_button = _.get(
    screens,
    "discovery.iam_button",

    "STEAL"
  );

  const iam_button_empty_none = _.get(
    screens,
    "discovery.iam_button_empty_none",

    "END TURN"
  );

  const iam_button_none = _.get(
    screens,
    "discovery.iam_button_none ",
    "END TURN"
  );

  const iam_empty_steal_info_1 = _.get(
    screens,
    "discovery.iam_empty_steal_info_1",

    "Bad news: you dug in the trash for nothing. Good news: you're a thief!"
  );
  const iam_empty_steal_info_2 = _.get(
    screens,
    "discovery.iam_empty_steal_info_2",

    "You couldn't get a card from the discard but stole a card from a fellow conspiracist."
  );

  const iam_info_empty_1 = _.get(
    screens,
    "discovery.iam_info_empty_1",
    "You've never seen a dumpster this clean before. At least you can try and steal some secrets still."
  );
  const iam_info_empty_2 = _.get(
    screens,
    "discovery.iam_info_empty_2",
    "The discard pile was empty, and you don't find anything."
  );
  const iam_info_empty_none_1 = _.get(
    screens,
    "discovery.iam_info_empty_none_1",
    "You were feeling tenacious, but the dumpsters are clean and nobody has any info to steal. That's rough, buddy."
  );
  const iam_info_empty_none_2 = _.get(
    screens,
    "discovery.iam_info_empty_none_2",

    "The discard pile is empty and no players have cards to steal right now."
  );

  const iam_info_none_1 = _.get(
    screens,
    "discovery.iam_info_none_1",
    "You got some good info from the trash, but then couldn't steal 'cuz noone had anything."
  );
  const iam_info_none_2 = _.get(
    screens,
    "discovery.iam_info_none_2",
    "You got a card from the discard pile, but couldn't steal from any players."
  );
  const iam_steal_button = _.get(
    screens,
    "discovery.iam_steal_button",
    "END TURN"
  );

  const iam_steal_info_1 = _.get(
    screens,
    "discovery.iam_steal_info_1",
    "Pick someone to steal a card from"
  );
  const iam_steal_info_2 = _.get(
    screens,
    "discovery.iam_steal_info_2",
    "Pick which card to take from this player."
  );
  const iam_steal_info_3 = _.get(
    screens,
    "discovery.iam_steal_info_3",
    "A little dumpster diving, a bit of petty theft. It's a good day for the truth."
  );
  const iam_title = _.get(
    screens,
    "discovery.iam_title",

    "IT'S ALL MINE!"
  );

  const sfw_button = _.get(
    screens,
    "discovery.sfw_button",

    "END TURN"
  );

  const sfw_info_1 = _.get(
    screens,
    "discovery.sfw_info_1",

    "Pick someone to steal a card from"
  );

  const sfw_info_2 = _.get(
    screens,
    "discovery.sfw_info_2",

    "Pick which card to take from this player."
  );

  const sfw_info_3 = _.get(
    screens,
    "discovery.sfw_info_3",

    "Knowledge is meant to be shared! You stole a card from one of your fellow conspiracists."
  );
  const sfw_info_empty_1 = _.get(
    screens,
    "discovery.sfw_info_empty_1",

    "You thought iot'd be a good idea to go steal someone else's secrets, but turns out they don't have any yet?"
  );
  const sfw_info_empty_2 = _.get(
    screens,
    "discovery.sfw_info_empty_2",

    "No players have cards to steal right now."
  );

  const sfw_title = _.get(
    screens,
    "discovery.sfw_title",

    "SHARE THE WEALTH!"
  );

  const dispatch = useDispatch();
  const diceValueDouble = diceData?.dice_special || 0;
  const discardCategory = diceData?.given_card || "";
  let categoryImage =
    discardCategory === "Tech"
      ? tech
      : discardCategory === "Random"
      ? random
      : discardCategory === "Mythos"
      ? mythos
      : discardCategory === "Schemes"
      ? schemes
      : aliens;

  const buttonPressAction = (type) => {
    let data = {};
    switch (type) {
      case "default":
        data = {
          action: "roll-dice",
          roomId,
          playerId: currentPlayer?.player_id,
          special: "Discover"
        };
        break;
      case "dice123":
        data = {
          action: "special-action",
          roomId,
          playerId: currentPlayer?.player_id,
          specialAction: "End Turn"
        };
        break;

      case "endturn":
        data = {
          action: "special-action",
          roomId,
          playerId: currentPlayer?.player_id,
          specialAction: "End Turn"
        };
        break;

      default:
        break;
    }
    Socket.sendMessage(data);
  };

  const onUpdateStatus = useCallback(
    _.debounce((type) => buttonPressAction(type), 1000, {
      leading: true,
      trailing: false
    }),
    [roomId]
  );

  const handleStealAction = () => {
    dispatch(set_ct_steal_button(true));
  };

  const diceValue = () => {
    switch (diceData?.dice_special) {
      case 1:
        return one;
      case 2:
        return two;
      case 3:
        return three;
      case 4:
        return four;
      case 5:
        return five;
      default:
        return six;
    }
  };
  return (
    <>
      {(() => {
        switch (diceValueDouble) {
          case 1:
          case 2:
          case 3:
            return (
              <DiscoveryDice123
                titleText={dd_title}
                text1={_.isEmpty(discard_pile) ? dd_info_empty_1 : dd_info_1}
                text2={_.isEmpty(discard_pile) ? dd_info_empty_2 : dd_info_2}
                isDiscardPileEmpty={!_.isEmpty(discard_pile)}
                categoryImage={categoryImage}
                buttonText={"end turn (10)"}
                buttonPress={() => onUpdateStatus("dice123")}
                diceValue={diceValue}
                buzzer_sound={buzzer_sound}
                default_audio_effect={default_audio_effect}
              />
            );
          case 4:
          case 5:
            return _.isEmpty(playersWithCard) ? (
              <DiscoverySingleCommon
                titleText={sfw_title}
                text1={
                  sfw_info_empty_1
                }
                text2={sfw_info_empty_2}
                buttonText={"end turn (10)"}
                buttonPress={() => onUpdateStatus("endturn")}
                diceValue={diceValue()}
                buzzer_sound={buzzer_sound}
                default_audio_effect={default_audio_effect}
              />
            ) : (
              <DiscoveryCardSelector
                roomId={roomId}
                diceValue={diceValue()}
                currentPlayer={currentPlayer}
                titleText={sfw_title}
                text1={
                  playerSelected === null
                    ?sfw_info_1
                    : _.isEmpty(cardSelected)
                    ?iam_steal_info_2
                    : sfw_info_3
                }
                playersWithCardInfo={playersWithCardInfo}
                playerSelected={playerSelected}
                cardSelected={cardSelected}
                buttonPress={() => onUpdateStatus("endturn")}
                buzzer_sound={buzzer_sound}
                default_audio_effect={default_audio_effect}
              />
            );
          case 6: {
            return !stealButton ? (
              <DiscoveryDice123
                titleText={iam_title}
                text1={
                  _.isEmpty(discard_pile)
                    ? iam_info_empty_1
                    : "They think they can hoard the truth. You know better. First, the trash. Then their files."
                }
                text2={
                  _.isEmpty(discard_pile)
                    ? 
                    iam_info_empty_2
                    
                    : `You found a ${discardCategory} card!`
                }
                isDiscardPileEmpty={!_.isEmpty(discard_pile)}
                categoryImage={categoryImage}
                buttonText={iam_button}
                buttonPress={() => handleStealAction()}
                diceValue={diceValue()}
                buzzer_sound={buzzer_sound}
                default_audio_effect={default_audio_effect}
              />
            ) : _.isEmpty(playersWithCard) ? (
              <DiscoverySingleCommon
                titleText={iam_title}
                diceValue={diceValue()}
                text1={
                  _.isEmpty(discard_pile)
                    ? iam_info_empty_none_1

                    : iam_info_none_1
                }
                text2={
                  _.isEmpty(discard_pile)
                    ? iam_info_empty_none_2
                    :iam_info_none_2
                }
                isDiscardPileEmpty={!_.isEmpty(discard_pile)}
                categoryImage={categoryImage}
                buttonText={"end turn (10)"}
                buttonPress={() => onUpdateStatus("endturn")}
                buzzer_sound={buzzer_sound}
                default_audio_effect={default_audio_effect}
              />
            ) : (
              <DiscoveryCardSelector
                roomId={roomId}
                diceValue={diceValue()}
                currentPlayer={currentPlayer}
                titleText={iam_title}
                text1={
                  playerSelected === null
                    ? sfw_info_1
                    : _.isEmpty(cardSelected)
                    ? sfw_info_2
                    : _.isEmpty(discard_pile)
                    ? "Bad news: you dug in the trash for nothing."
                    : iam_steal_info_3
                }
                text2={
                  playerSelected != null &&
                  !_.isEmpty(cardSelected) &&
                  _.isEmpty(discard_pile)
                    ? "Good news: you're a thief!"
                    : ""
                }
                text3={
                  playerSelected != null &&
                  !_.isEmpty(cardSelected) &&
                  _.isEmpty(discard_pile)
                    ? iam_empty_steal_info_2
                    : ""
                }
                playersWithCardInfo={playersWithCardInfo}
                playerSelected={playerSelected}
                cardSelected={cardSelected}
                isDiceSpecial6={true}
                buzzer_sound={buzzer_sound}
                default_audio_effect={default_audio_effect}
              />
            );
          }

          default:
            return (
              <DefaultDiscoverScreen
                buttonPress={() => onUpdateStatus("default")}
                text={
                  discovery_info
                }
                diceText={discovery_button}
                titleText={discovery_title}
                buzzer_sound={buzzer_sound}
                default_audio_effect={default_audio_effect}
              />
            );
        }
      })()}
    </>
  );
};

export default DiscoveryScreen;
